(function () {
  'use strict';

  angular.module('app').service('HotelInventoryModalService', HotelInventoryModalService);

  HotelInventoryModalService.$inject = ['ModalService'];

  function HotelInventoryModalService(ModalService) {
    var service = {
      openHotelInventoryModal: openHotelInventoryModal,
    };

    return service;

    ///////////////////////

    function openHotelInventoryModal(item, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/hotel-inventories/modals/hotel-inventory-modal.html',
        controller: HotelInventoryModalCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });
    }

    function HotelInventoryModalCtrl($element, item, successCallback) {
      var vm = this;

      vm.item = item;

      vm.modalTitle = 'UPDATE_INVENTORY';

      vm.onInventorySaved = onInventorySaved;

      function onInventorySaved() {
        $element.modal('hide');
        successCallback();
      }
    }
  }
})();
